/* Saint Texas — hat behaviour inside Horizon's quick-add modal.

   The modal builds its contents by fetching the product page and morphing the
   markup in. Injected <script> tags don't run, and the mobile layout throws the
   details column away entirely, so the product page's own "Customize This Hat"
   block can arrive half-alive or not at all. Since hats have no add-to-cart,
   that leaves the shopper with a colour picker and no way forward.

   This guarantees the way forward: whenever the modal opens for a hat, it makes
   sure a Customize block exists, pins it to the bottom of the panel, and lets
   st-customize-cta.js keep its link in step with the selected colour. Swatches
   come from st-swatches.js, which is loaded site-wide for the same reason. */
(function () {
  "use strict";
  if (window.__stQuickAddLoaded) return;
  window.__stQuickAddLoaded = true;

  var cfg = {};
  try {
    var el = document.getElementById("st-quick-add-config");
    if (el) cfg = JSON.parse(el.textContent || "{}");
  } catch (e) { /* defaults below */ }

  var LABEL = cfg.label || "Customize Now →";
  var HELPER = cfg.helper || "";
  var BUILDER = cfg.builderUrl || "";

  // Which product the shopper opened. Set on click, because the modal markup
  // itself doesn't say which card it came from.
  var current = null;

  document.addEventListener(
    "click",
    function (e) {
      var btn = e.target.closest && e.target.closest(".quick-add__button");
      if (!btn) return;
      var host = btn.closest("quick-add-component");
      if (!host || host.getAttribute("data-st-hat") !== "true") return;
      current = { productUrl: host.getAttribute("data-st-product-url") || "" };
      document.documentElement.classList.add("st-swatch-boot");
      // Failsafe: if the swatches never draw, show the plain picker rather than
      // leaving the colour buttons hidden by the boot rule.
      setTimeout(function () {
        var modal = document.getElementById("quick-add-modal-content");
        if (!modal || !modal.querySelector(".st-swatch-set")) {
          document.documentElement.classList.remove("st-swatch-boot");
        }
      }, 2500);
    },
    true
  );

  function productUrlFrom(modal) {
    var block = modal.querySelector(".st-cta-block[data-product-url]");
    if (block) return block.getAttribute("data-product-url");
    if (current && current.productUrl) return current.productUrl;
    var link = modal.querySelector('a[href*="/products/"]');
    return link ? link.getAttribute("href").split("?")[0] : "";
  }

  function ensure(modal) {
    var picker = modal.querySelector("variant-picker");
    if (!picker) return;

    var block = modal.querySelector(".st-cta-block");

    // Normally the click on a hat card tells us which product this is. If that
    // didn't happen for any reason, a .st-cta-block carried over from the
    // product page is proof enough that this is a hat.
    if (!current && !block) return;

    if (!block) {
      if (!BUILDER) return;
      block = document.createElement("div");
      block.className = "st-cta-block";
      block.setAttribute("data-builder-url", BUILDER);
      var a = document.createElement("a");
      a.className = "st-cta-block__btn";
      a.setAttribute("href", "#");
      a.textContent = LABEL;
      block.appendChild(a);
      if (HELPER) {
        var p = document.createElement("p");
        p.className = "st-cta-block__helper";
        p.textContent = HELPER;
        block.appendChild(p);
      }
    }

    var url = productUrlFrom(modal);
    if (url) block.setAttribute("data-product-url", url);
    if (BUILDER && !block.getAttribute("data-builder-url")) block.setAttribute("data-builder-url", BUILDER);

    // Sit directly after the colour picker. The picker is the one element that
    // is definitely rendered and visible whichever layout branch the modal took
    // (desktop keeps the whole details column, mobile strips it to the picker),
    // so a sibling right after it lands in the same visible flow. Appending to
    // the modal's grid container instead leaves it auto-placed and off-screen.
    block.classList.add("st-cta-block--quick-add");
    block.setAttribute("data-st-quick-cta", "true");
    if (picker.nextElementSibling !== block) {
      picker.parentNode.insertBefore(block, picker.nextSibling);
    }

    if (window.stCustomizeCta) {
      block.__stCtaReady = false;
      window.stCustomizeCta.init(block);
      window.stCustomizeCta.refresh(block);
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    // setTimeout, not requestAnimationFrame: rAF does not fire while a tab is
    // backgrounded or has no layout yet, which left this work permanently queued.
    setTimeout(function () {
      queued = false;
      var modal = document.getElementById("quick-add-modal-content");
      if (modal) ensure(modal);
    }, 0);
  }

  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var t = records[i].target;
      if (t.nodeType !== 1) continue;
      if ((t.id === "quick-add-modal-content") || (t.closest && t.closest("#quick-add-modal-content"))) { schedule(); return; }
      for (var j = 0; j < records[i].addedNodes.length; j++) {
        var n = records[i].addedNodes[j];
        if (n.nodeType === 1 && (n.id === "quick-add-modal-content" || (n.querySelector && n.querySelector("#quick-add-modal-content")))) { schedule(); return; }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Leaving the modal clears the hat flag and the boot rule.
  document.addEventListener("click", function (e) {
    if (e.target.closest && e.target.closest(".quick-add-modal__close")) {
      current = null;
      document.documentElement.classList.remove("st-swatch-boot");
    }
  });
})();
